import { useMemo } from 'react';
import { useStore } from '@/state/store';
import { generateNarrative } from '@/content/narrative';

/** Plain-language results narrative + contextual warnings (§10.8, Appendix C). */
export function Narrative() {
  const result = useStore((s) => s.result);
  const inputs = useStore((s) => s.inputs);
  const narrative = useMemo(() => (result ? generateNarrative(result, inputs) : null), [result, inputs]);
  if (!narrative) return null;
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3 text-sm leading-relaxed shadow-sm dark:border-slate-700 dark:bg-slate-800">
      <h3 className="mb-1 text-sm font-semibold text-slate-700 dark:text-slate-200">What this means</h3>
      {narrative.paragraphs.map((p, i) => (
        <p key={i} className="mb-1 text-slate-700 dark:text-slate-300">{p}</p>
      ))}
    </div>
  );
}

/** Contextual warning banners (§10.8, Appendix C). */
export function WarningsBanner() {
  const result = useStore((s) => s.result);
  const inputs = useStore((s) => s.inputs);
  const narrative = useMemo(() => (result ? generateNarrative(result, inputs) : null), [result, inputs]);
  if (!narrative || narrative.warnings.length === 0) return null;
  return (
    <div className="flex flex-col gap-1" role="status">
      {narrative.warnings.map((w, i) => (
        <div key={i} className="rounded border border-caution/40 bg-caution-bg px-3 py-1.5 text-xs text-caution">
          {w}
        </div>
      ))}
    </div>
  );
}
